import React, { forwardRef } from 'react';
import Proptypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Popper, ClickAwayListener } from '@material-ui/core';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';

const useStyles = makeStyles(theme => {
  return {
    root: {
      '& button': {
        height: 40,
        width: 120,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: 'transparent',
        borderWidth: 1,
        borderRadius: 4,
        borderColor: '#cfdCED',
        borderStyle: 'solid',
        padding: '0 12px 0 16px',
        color: '#8288A0',
        outline: 'none',
        fontFamily: 'nunito sans, sans-serif',
        fontSize: '14px',
      },
      '& button:focus, & button:active': {
        border: `2px solid ${theme.palette.primary.main}`,
      },
    },
  };
});

const PricePopper = forwardRef(function PricePopper(
  {
    className,
    children,
    anchorEl,
    onButtonClick,
    buttonText,
    placement,
    isOpen,
    onPopperClose,
    ...restProps
  },
  ref
) {
  const { root } = useStyles({ isOpen });

  return (
    <ClickAwayListener onClickAway={onPopperClose}>
      <div className={clsx(className, root)} ref={ref} {...restProps}>
        <button
          type="button"
          className="price-button"
          style={{}}
          name="price"
          onClick={onButtonClick}
        >
          {buttonText}
          <div
            style={{
              backgroundColor: 'rgba(69, 77, 204, 0.08)',
              height: 16,
              width: 16,
              borderRadius: 8,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <KeyboardArrowDown
              style={{
                height: 16,
                width: 16,
                transition: isOpen ? 'transform 0.25s ease-in-out' : '',
              }}
            />
          </div>
        </button>
        <Popper
          style={{
            boxShadow: '0px 20px 25px rgba(0, 0, 0, 0.1), 0px 0px 20px rgba(0, 0, 0, 0.1)',
            borderRadius: 8,
            marginTop: 8,
            padding: '20px 8px 8px',
            zIndex: 10000,
            backgroundColor: '#FFF',
          }}
          anchorEl={anchorEl}
          open={isOpen}
          placement={placement}
        >
          {children}
        </Popper>
      </div>
    </ClickAwayListener>
  );
});

PricePopper.propTypes = {
  className: Proptypes.string,
  children: Proptypes.node,
  /** Provide function to open popper on button click */
  onButtonClick: Proptypes.func.isRequired,
  /** DOM Element the popper needs to attach to. Generally using event.currentTarget */
  anchorEl: Proptypes.node,
  isOpen: Proptypes.bool.isRequired,
  placement: Proptypes.string,
  /** function to close popper on click outside of popper (Not default functionality) */
  onPopperClose: Proptypes.func.isRequired,
  buttonText: Proptypes.string,
};

PricePopper.defaultProps = {
  className: null,
  children: null,
  anchorEl: null,
  placement: 'bottom-start',
  buttonText: 'Price',
};

PricePopper.displayName = 'PricePopper';

export default PricePopper;
